const s = (e) => e && `theme_${e}`;
function o({
  stylesNew: e,
  stylesOld: t,
  theme: n
}) {
  return n === "new" ? e : t;
}
export {
  s as getThemeCSSClass,
  o as getThemeStyles
};
